import { z } from "zod";

export const MESSAGING_PROMPT_REQUEST_EVENT = "garimpa:messaging-prompt-request";
export const MESSAGING_PROMPT_REQUEST_STORAGE_KEY = "garimpa.messagingPrompt.request.v2";
export const MESSAGING_PROMPT_REQUEST_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export const messagingPromptRequestSchema = z.object({
  reason: z.literal("price_alert_created"),
  surface: z.string().trim().min(1).max(100),
  selectionScope: z.string().trim().min(1).max(50),
  format: z.string().trim().min(1).max(50).optional(),
  requestedAt: z.number().int().nonnegative(),
});

export type MessagingPromptRequest = z.infer<typeof messagingPromptRequestSchema>;
